import { grey } from '@mui/material/colors';

export default {
  root: {
    backgroundColor: grey[50],
  },
};
